import { ReactNode } from "react";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import Icon from "apps/website/components/base/Icon/Icon";
import cx from "apps/website/utils/misc/cx";

import { IListOption } from "../RadioButtons.types";

function renderWrappedIcon(props: IListOption, invertIcon: boolean): ReactNode {
  const iconSvg = props.selected && props.selectedIcon
    ? props.selectedIcon
    : props.icon;
  if (!iconSvg){ return null; }
  return (
    <div className={cx(invertIcon && "text-white")}>
      <Icon icon={iconSvg} size="medium" className="mr-3" color="inherit" />
    </div>
  );
}

function getContainerClassName(selected?: boolean, isRightAligned?: boolean) {
  return cx(
    "list-option flex items-start border rounded-md py-3 px-3",
    "md:rounded-lg md:py-4",
    selected ? "bg-black text-white" : "border border-solid border-outline-grey bg-white",
    isRightAligned && "justify-between",
  );
}

function renderDescription(
  description: string | undefined,
  selected: boolean | undefined,
  size: Parameters<typeof TextBody>[0]["size"],
): ReactNode {
  if (!description){ return null; }
  return (
    <TextBody size={size} className={cx(selected && "text-white", "transition-none")}>
      { description }
    </TextBody>
  );
}

const ListOption = (props: IListOption) => {
  const {
    iconPosition = "left",
    invertIconOnSelect = false,
    labelTextSize = 2,
    descriptionTextSize = 2,
  } = props.styleOptions ?? {};

  const iconWrapper = renderWrappedIcon(props, !!(invertIconOnSelect && props.selected));

  return (
    <div
      data-testid="list-option-container"
      data-component={props.component ?? ListOption.name}
      data-value={props.value}
      aria-disabled={props.disabled || undefined}
      className={getContainerClassName(props.selected, iconPosition === "right")}
    >
      { iconPosition === "left" && iconWrapper }
      <div className="flex flex-col gap-1 mt-0.5">
        <TextSubtitle size={labelTextSize}>
          { props.label }
        </TextSubtitle>
        { renderDescription(props.description, props.selected, descriptionTextSize) }
      </div>
      { iconPosition === "right" && iconWrapper }
    </div>
  );
};

export default ListOption;
